<span *ngIf="meta" class="mode-chip" [ngClass]="'mode-chip--' + mode" role="status">
  <i [class]="meta.icon" aria-hidden="true"></i>
  {{ meta.label }}
</span>
